import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import SideBar from "../../SideBar";
import { useNavigate } from "react-router-dom";

import Swal from "sweetalert2";
import { FaCashRegister, FaRegTrashAlt, FaRegEdit } from "react-icons/fa";
import HeaderName from "../../HeaderName";
import { useSelector } from "react-redux";

import { Checkbox, Radio } from "@mui/material";
import { api } from "../../../../api/api";

function DiscountRule() {


    const [fromAmount, setFromAmount] = useState('');
    const [pointList, setPointList] = useState([]);
    const [toAmount, setToAmount] = useState("");
    const [below, setBelow] = useState(false);
    const [above, setAbove] = useState(false);
    const [description, setDescription] = useState(null);
    const [showUpdate, setShowUpdate] = useState(false);
    const [discount, setDiscount] = useState([]);
    const [type, setType] = useState("");
    const [upName, setUpName] = useState("");
    const [upDesc, setUpDesc] = useState("");
    const [relatedCat, setRelatedCat] = useState("");
    const [relatedCatID, setRelatedCatID] = useState("");
    const [Id, setId] = useState("");
    const navigate = useNavigate();

    // const [categoryLists, setCategoryLists] = useState([]);

    const handleDelete = (event) => {
        api
            .delete("sub-category/" + event)
            .then((response) => {
                Swal.fire({
                    title: "Success",
                    text: "Successfully Deleted!",
                    icon: "success",
                    confirmButtonText: "OK",
                });
                const result = pointList.filter((item) => item._id !== event);
                setPointList(result);
            })
            .catch((error) => {
                Swal.fire({
                    title: "Error",
                    text: error.response.data.message,
                    icon: "error",
                    confirmButtonText: "CANCEL",
                });
            });
    };

    const handleUpdate = (event) => {
        // console.log(event, 'event')
        const getCatUpdate = async () => {
            try {
                const res = await api.get("v1/point-discount-rule/" + event);
                console.log(res.data.data);
                setDiscount(res.data.data.percent);
                setType(res.data.data.type);
                setFromAmount(res.data.data.from);
                setToAmount(res.data.data.to);
                setDescription(res.data.data.description);

            } catch (err) { }
        };
        getCatUpdate();
        setShowUpdate(true);
        setId(event);
    };

    const Update = () => {
        const data = {
            from: fromAmount,
            to: toAmount,
            type: type,
            percent: discount,
            description: description,
        };


        const config = {
            headers: { "Content-Type": "application/json" },
        };
        api
            .put("v1/point-discount-rule/" + Id, data, config)
            .then(function (response) {
                Swal.fire({
                    title: "Successful!",
                    text: "You Updated Data!",
                    icon: "success",
                    // showCancelButton: true,

                    showConfirmButton: false,
                    timer: 3000
                });
                // window.location.reload();

                //  setSubCategoryLists([...subCategoryLists, response.data.data]);
                setPointList(
                    pointList.map((category) => {
                        if (category._id === response.data.data._id) {
                            return response.data.data;
                        } else {
                            return category;
                        }
                    })
                );
            })
            .catch(function (err) {
                Swal.fire({
                    title: "Something Wrong!",
                    text: "Try again, Please.",
                    icon: "warning",
                    // showCancelButton: true,

                    cancelButtonText: "Close",
                });
            });
        document.getElementById("desc").value = "";
        document.getElementById("name").value = "";
        document.getElementById("code").value = "";
        document.getElementById("cat").value = "";
    };

    const Create = () => {
        const data = {
            from: fromAmount,
            to: toAmount,
            type: type,
            percent: discount,
            description: description,
        };

        // alert(JSON.stringify(data));

        const config = {
            headers: { "Content-Type": "application/json" },
        };
        api
            .post("v1/point-discount-rule", data, config)
            .then(function (response) {
                Swal.fire({
                    title: "Successful!",
                    text: "You Created Data!",
                    icon: "success",
                    showConfirmButton: false,
                    timer: 3000
                });


                setPointList([...pointList, response.data.data]);
            })
            .catch(function (err) {
                Swal.fire({
                    title: "Something Wrong!",
                    text: "Try again, Please.",
                    icon: "warning",
                    showCancelButton: false,
                    timer: 3000

                });
            });
        document.getElementById("desc").value = "";
        document.getElementById("name").value = "";
        document.getElementById("code").value = "";
        document.getElementById("cat").value = "";
    };
    useEffect(() => {

        const getSubCategory = async () => {
            try {
                const res = await api.get("v1/point-discount-rule");

                console.log(res.data.data, "sub cat");
                setPointList(res.data.data);
            } catch (err) { }
        };

        getSubCategory();
    }, []);
    return (
      <>
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-12">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item active fs-5">
                    Discount Rules List
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- Main content --> */}

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-9">
                <div className="card">
                  <div className="card-header">
                    {/* <h3 className="card-title">Cost Center List</h3> */}
                  </div>
                  <div className="card-body">
                    <table id="example1" className="table">
                      <thead className=" bg-info">
                        <tr>
                          <th>No</th>
                          <th>Type</th>
                          <th>From</th>
                          <th>To</th>
                          <th>Discount %</th>
                          <th>Last Updated</th>
                          <th>Description</th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      {pointList.map((cat, i) => (
                        <tbody className="">
                          <tr>
                            <td>{++i}</td>
                            <td>{cat.type}</td>
                            <td>{cat.from}</td>
                            <td>{cat.to}</td>
                            <td>{cat.percent}</td>
                            <td>{cat.date?.split("T")[0]}</td>
                            <td>{cat.description}</td>
                            <td>
                              <button
                                className="btn btn-sm btn-warning"
                                onClick={(e) => handleUpdate(cat._id)}
                              >
                                <FaRegEdit />
                              </button>
                              &nbsp;
                              {/* <button
                                                                    className='btn btn-sm btn-danger'
                                                                    onClick={(e) => handleDelete(cat._id)}
                                                                >
                                                                    <FaRegTrashAlt />
                                                                </button> */}
                            </td>
                          </tr>
                        </tbody>
                      ))}
                    </table>
                  </div>
                </div>
              </div>

              {showUpdate ? (
                <div className="col-md-3">
                  <div className="card">
                    <h5 className="card-header mb-4 fw-5 text-secondary py-3">
                      Update Discount Rule
                    </h5>
                    <div className="px-3 py-3">
                      <div class="form-group">
                        <label for="name">Type</label>
                        <select
                          class="custom-select border-info"
                          name="account_type_id"
                          value={type}
                          id="cat"
                          onChange={(e) => setType(e.target.value)}
                        >
                          {/* <option value={type} hidden>{type}</option> */}

                          <option value="Aesthetic">Aesthetic</option>
                          <option value="Surgery">Surgery</option>
                          <option value="Pharmacy">Pharmacy</option>
                        </select>
                      </div>
                      <div className="row">
                        <div class="form-group col-12">
                          <label for="name">From</label>
                          <input
                            type="number"
                            class="form-control border-info"
                            name="code"
                            id="code"
                            value={fromAmount}
                            // disabled={below ? true : false}
                            //   ref={(el) => (this.name = el)}
                            onChange={(e) => setFromAmount(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div class="form-group col-12">
                          <label for="name">To</label>
                          {console.log(above, "ab")}
                          <input
                            type="number"
                            class="form-control border-info"
                            name="code"
                            id="code"
                            value={toAmount}
                            // disabled={above ? true : false}
                            //   ref={(el) => (this.name = el)}
                            onChange={(e) => setToAmount(e.target.value)}
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="name" className="text-secondary">
                          Discount %
                        </label>
                        <input
                          type="number"
                          class="form-control border-info"
                          name="balance"
                          id="name"
                          value={discount}
                          //   ref={(el) => (this.name = el)}
                          onChange={(e) => setDiscount(e.target.value)}
                        />
                      </div>

                      <div class="form-group">
                        <label for="name" className="text-secondary">
                          Description
                        </label>
                        <textarea
                          className="form-control"
                          id="desc"
                          value={description}
                          //   ref={(el) => (this.description = el)}
                          onChange={(e) => setDescription(e.target.value)}
                        ></textarea>
                      </div>
                      <button
                        style={{ backgroundColor: "#0b9490", color: "white" }}
                        className="btn  form-control text-center fw-5"
                        onClick={Update}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="col-md-3">
                  <div className="card">
                    <h5 className="card-header mb-4 fw-5 text-secondary py-3">
                      Create Discount Rule
                    </h5>
                    <div className="px-3 py-3">
                      <div class="form-group">
                        <label for="name">Type</label>
                        <select
                          class="custom-select border-info"
                          name="account_type_id"
                          id="cat"
                          onChange={(e) => setType(e.target.value)}
                        >
                          <option hidden>Choose Category</option>

                          <option value="Aesthetic">Aesthetic</option>
                          <option value="Surgery">Surgery</option>
                          <option value="Pharmacy">Pharmacy</option>
                        </select>
                      </div>
                      <div className="row">
                        <div class="form-group col-12">
                          <label for="name">From</label>
                          <input
                            type="number"
                            class="form-control border-info"
                            name="code"
                            id="code"
                            // disabled={below ? true : false}
                            //   ref={(el) => (this.name = el)}
                            onChange={(e) => setFromAmount(e.target.value)}
                          />
                        </div>
                        {/* <div class='form-group col-4' style={{ marginTop: '2rem' }}>

                                                        <label for='name'>Below</label>
                                                        <Checkbox className='' disabled={fromAmount} onChange={() => setBelow(!below)} />

                                                    </div> */}
                      </div>

                      <div className="row">
                        <div class="form-group col-12">
                          <label for="name">To</label>
                          {console.log(above, "ab")}
                          <input
                            type="number"
                            class="form-control border-info"
                            name="code"
                            id="code"
                            // disabled={above ? true : false}
                            //   ref={(el) => (this.name = el)}
                            onChange={(e) => setToAmount(e.target.value)}
                          />
                        </div>
                        {/* <div class='form-group col-4' style={{ marginTop: '2rem' }}>

                                                        <label for='name'>Above</label>
                                                        <Checkbox disabled={toAmount && true} className='' onChange={() => setAbove(!above)} />

                                                    </div> */}
                      </div>
                      <div class="form-group">
                        <label for="name" className="text-secondary">
                          Discount %
                        </label>
                        <input
                          type="number"
                          class="form-control border-info"
                          name="balance"
                          id="name"
                          //   ref={(el) => (this.name = el)}
                          onChange={(e) => setDiscount(e.target.value)}
                        />
                      </div>

                      <div class="form-group">
                        <label for="name" className="text-secondary">
                          Description
                        </label>
                        <textarea
                          className="form-control"
                          id="desc"
                          //   ref={(el) => (this.description = el)}
                          onChange={(e) => setDescription(e.target.value)}
                        ></textarea>
                      </div>
                      <button
                        style={{ backgroundColor: "#0b9490", color: "white" }}
                        className="btn  form-control text-center fw-5"
                        onClick={Create}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          {/*<!-- /.container-fluid --> */}
        </section>
      </>
    );
}
export default DiscountRule;
